import { useState } from 'react';
import { record } from '@solimat/solimat-web-endpoint';

type StatusGetSolicitudCATAFuegoByUser = {
    status: number | null;
    statusText: string | null;
};

const getBackendMessage = (error: any) => {
    const responseData = error?.response?.data;
    return (
        (typeof responseData === 'string' ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        error?.response?.statusText ||
        error?.message ||
        'Error'
    );
};

const useGetSolicitudCATAFuegoByUser = () => {
    const [loadingGetSolicitudCATAFuegoByUser, setLoadingGetSolicitudCATAFuegoByUser] = useState(false);
    const [successGetSolicitudCATAFuegoByUser, setSuccessGetSolicitudCATAFuegoByUser] = useState(false);
    const [errorGetSolicitudCATAFuegoByUser, setErrorGetSolicitudCATAFuegoByUser] = useState<any>(null);
    const [dataGetSolicitudCATAFuegoByUser, setDataGetSolicitudCATAFuegoByUser] = useState<any>(null);
    const [statusGetSolicitudCATAFuegoByUser, setStatusGetSolicitudCATAFuegoByUser] = useState<StatusGetSolicitudCATAFuegoByUser>({
        status: null,
        statusText: null,
    });

    const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || '';
    const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || '';
    const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

    const getSolicitudCATAFuegoByUser = async (
        userId: string,
        expedienteId: string | number | null = null,
        callback?: (data: any) => void
    ) => {
        setLoadingGetSolicitudCATAFuegoByUser(true);
        setSuccessGetSolicitudCATAFuegoByUser(false);
        setErrorGetSolicitudCATAFuegoByUser(null);

        try {
            const response = await apiRecord.getSolicitudCataFmIncendioByUser(userId);
            // La versión actual del SDK no admite expedienteId en esta operación.
            const forms = expedienteId !== null && expedienteId !== undefined && expedienteId !== '' && Array.isArray(response.data)
                ? response.data.filter((form: any) =>
                    [form?.IdExternalPrestacion, form?.ExpedienteId].some((id) => String(id ?? '') === String(expedienteId))
                )
                : response.data;
            setStatusGetSolicitudCATAFuegoByUser({
                status: response.status,
                statusText: response.statusText ?? response.response ?? null,
            });
            setSuccessGetSolicitudCATAFuegoByUser(true);
            setDataGetSolicitudCATAFuegoByUser(forms);
            callback?.(forms);
            return forms;
        } catch (error: any) {
            setStatusGetSolicitudCATAFuegoByUser({
                status: error?.response?.status || 500,
                statusText: getBackendMessage(error),
            });
            setErrorGetSolicitudCATAFuegoByUser(error);
            throw error;
        } finally {
            setLoadingGetSolicitudCATAFuegoByUser(false);
        }
    };

    return {
        getSolicitudCATAFuegoByUser,
        loadingGetSolicitudCATAFuegoByUser,
        successGetSolicitudCATAFuegoByUser,
        errorGetSolicitudCATAFuegoByUser,
        dataGetSolicitudCATAFuegoByUser,
        statusGetSolicitudCATAFuegoByUser,
    };
};

export default useGetSolicitudCATAFuegoByUser;
